import {
	buildGETContract,
	serializePathBasic,
	HttpStatus,
	CommonResponses,
} from "@/common/contracts";
import { z } from "zod";
import { GetCurrentUserOutputSchema } from "./GetCurrentUserOutput";
import { UserRole } from "@/users/models/UserRole";
export const GetCurrentUserContract = buildGETContract({
	path: "/users/current",
	method: "GET",
	search: z.object({}),
	params: z.object({}),

	serializePath(
		params: z.infer<typeof this.params>,
		search: z.infer<typeof this.search>,
	) {
		return serializePathBasic(this.path, params, search);
	},
	response: z.discriminatedUnion("status", [
		...CommonResponses,
		z.object({
			status: z.literal(HttpStatus.Success),
			body: GetCurrentUserOutputSchema,
		}),
	]),
});
